import ImageMapIsommetry from './ImageMapIsometry';

export default ImageMapIsommetry;